import { Edge, Node } from "@xyflow/react";

import { MyNode, NodeData } from "../types/node-data.types";

/**
 * Walking the campaign canvas.
 *
 * `CampaignPage` keeps the graph in two mutable refs and used to traverse it with closures over
 * them, which made every walk untestable without mounting ReactFlow. These take the arrays, so the
 * traversal can be exercised on two literals — including the shapes that only occur when an edge
 * points backwards (see `hasPrecedingNodeOfType`).
 */

/** The node the single incoming edge of `nodeId` comes from, or null when it has none. */
export const findPreviousNode = (
	nodes: MyNode[],
	edges: Edge[],
	nodeId: string
): Node<NodeData> | null => {
	const previousNodeEdge = edges.find((edge) => edge.target === nodeId);

	if (!previousNodeEdge) {
		return null;
	}

	return nodes.find((node) => node.id === previousNodeEdge.source) ?? null;
};

/** Every node reachable from `nodeId` by one outgoing edge (both arms of a conditional step). */
export const findChildrenNodes = (
	nodes: MyNode[],
	edges: Edge[],
	nodeId: string
): Node<NodeData>[] => {
	const childrenNodesEdges = edges.filter((edge) => edge.source === nodeId);

	return nodes.filter((node) => childrenNodesEdges.some((edge) => edge.target === node.id));
};
